import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx'; // ← PERBAIKAN: import App.jsx
import reportWebVitals from './reportWebVitals';
import './styles/index.css';

/**
 * ============================================
 * ZENTRA - Main Entry Point
 * ============================================
 *
 * Ini adalah entry point utama aplikasi ZENTRA.
 * File ini bertanggung jawab untuk me-render
 * komponen App ke dalam DOM.
 * ============================================
 */

// ===== CREATE ROOT =====
// Mengambil elemen root dari public/index.html
const root = ReactDOM.createRoot(document.getElementById('root'));

// ===== RENDER APP =====
// Me-render komponen App dengan StrictMode untuk
// mendeteksi masalah potensial di development
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ===== REPORT WEB VITALS =====
// Mengukur performa aplikasi (opsional)
// Untuk mengirim ke analytics, ubah parameter di reportWebVitals
reportWebVitals();

// ===== SERVICE WORKER =====
// Jika ingin menggunakan service worker untuk PWA:
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// serviceWorkerRegistration.register();

// ===== LOGGING =====
// Log environment untuk debugging
if (process.env.NODE_ENV === 'development') {
  console.log('🚀 ZENTRA App started in development mode');
  console.log(`📦 Version: ${process.env.REACT_APP_VERSION || '1.0.0'}`);
  console.log(`🔧 API URL: ${process.env.REACT_APP_API_URL || 'Not set'}`);
}

// ===== ERROR HANDLING =====
// Global error handler untuk uncaught errors
if (process.env.NODE_ENV === 'production') {
  // Tangani error global
  window.addEventListener('error', (event) => {
    console.error('Global error caught:', event.error);
    // Kirim ke service monitoring (Sentry, LogRocket, dll)
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
    // Kirim ke service monitoring
  });
}
